import BaseComponent from "@js/components/base_component.jsx";

class EuiRoutesForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  render() {
    const route = this.props.route;

    return (
      <div>

        <ErrorBanner entity={ route } />

        <Panel heading="route">
          <div className="form-horizontal">

            <InputField
              object={ route }
              type="route"
              field="name"
              editing={ this.props.editing }
            />

            <InputField
              object={ route }
              type="route"
              field="requested_target_daily_volume"
              editing={ this.props.editing }
            />

            {/* Overflow routes are temporarily switched off
                (Eui::Route::OVERFLOW_ROUTES_ENABLED). The server stops sending
                the list of routes to choose from, which is what takes the field
                away — from the read-only view as well as the edit form. */}
            { this.props.overflow_routes && (
              <SelectField
                field="route.overflow_route_id"
                blank="overflow_route"
                value={ route.overflow_route_id }
                options={ this._overflowRouteOptions() }
                editing={ this.props.editing }
                error={ route.errors ? route.errors.overflow_route_id : null }
                showHrefFn={ (id) => Routes.eui_route_path(id) }
              />
            ) }

          </div>
        </Panel>

        { !this.props.editing && (
          <Panel heading="route_read_only_fields">
            <div className="form-horizontal">

              <FieldContainer labelText={ I18n.t("simple_form.labels.route.recommended_max_daily_volume") }>
                { route.recommended_max_daily_volume && route.recommended_max_daily_volume.toLocaleString() }
              </FieldContainer>

              <FieldContainer labelText={ I18n.t("simple_form.labels.route.recommended_max_delivery_rate_per_hour") }>
                { route.recommended_max_delivery_rate_per_hour && route.recommended_max_delivery_rate_per_hour.toLocaleString() }
              </FieldContainer>

              { route.routing_rule_id && (
                <FieldContainer labelText={ I18n.t("simple_form.labels.route.routing_rule") }>
                  <a href={ Routes.eui_virtual_mta_entity_path(route.routing_rule_id) }>
                    { route.routing_rule_name }
                  </a>
                </FieldContainer>
              )}

            </div>
          </Panel>
        )}

      </div>
    );
  }

  _overflowRouteOptions() {
    return (this.props.overflow_routes || []).map(function(r) {
      return { value: r.id, label: r.name };
    });
  }

}

export default EuiRoutesForm;
